<template>
  <div class="mainNew">
    <div class="topTitle">
      <span style="font-family:'PingFangBold';color:#333333;font-size: 16px;">系统设置</span>
      / 基础设置
    </div>
    <div class="container">
      <el-tabs v-model="activeName" @tab-click="handleClick">
        <el-tab-pane label="课程" name="first">
          <div style="overflow: hidden;">
            <div class="fl">
              <el-form :inline="true" :model="formInline" size="small" @submit.native.prevent>
                <el-form-item label="">
                  <el-input v-model="formInline.user" placeholder="请输入课程名称" clearable style="width:300px;" @keyup.enter.native="search" @change="search"></el-input>
                </el-form-item>
                <el-form-item label="">
                  <el-button type="primary" @click="search">查询</el-button>
                </el-form-item>
                <el-form-item label="">
                  <el-button type="primary" @click="addSub">新增课程</el-button>
                </el-form-item>
              </el-form>
            </div>
            <div class="fr">
              <el-form :inline="true" size="mini">
                <el-form-item label="商品状态:">
                  <el-radio-group v-model="formInline.resource" @change="search">
                    <el-radio label="1">售卖中</el-radio>
                    <el-radio label="2">已下架</el-radio>
                  </el-radio-group>
                </el-form-item>
              </el-form>
            </div>
          </div>
          <el-table :data="tableData" stripe style="width: 100%" :header-cell-style="{ background: '#f5f7fa' }">
            <el-table-column prop="" label="序号" width="50px">
              <template slot-scope="scope">{{ scope.$index + 1 + (page_no - 1) * page_size }}</template>
            </el-table-column>
            <el-table-column prop="name" label="课程名称" width="200"> </el-table-column>
            <!-- <el-table-column prop="name" label="收费方式">
                        </el-table-column> -->
            <el-table-column prop="" label="定价标准">
              <template slot-scope="scope">
                <div v-for="(item, key) in scope.row.rule_pricePase" :key="key">
                  <span>ꔷ </span>
                  <span>
                    {{ item.name }}
                  </span>
                  <span style="margin-left:10px;">( {{ item.unit_price.toFixed(2) }}元/课时</span>
                  <span style="margin-left:10px;">{{ item.acount }}课时 )
                  </span>
                </div>
              </template>
            </el-table-column>
            <el-table-column prop="stuBuyNum" label="已售出" width="100"> </el-table-column>
            <el-table-column prop="campus_name_str" label="所属校区" width="150"> </el-table-column>
            <el-table-column prop="remark" label="备注"> </el-table-column>
            <el-table-column prop="" label="商品状态" width="100">
              <template slot-scope="scope">
                <span v-if="scope.row.state == 1">
                  <svg t="1690013932997" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="9050" width="10" height="10">
                    <path d="M512 192a320 320 0 1 1-0.064 640.064A320 320 0 0 1 512 192z" fill="#B2CA5F" p-id="9051">
                    </path>
                    <path d="M512 895.872c-211.776 0-384-172.16-384-383.936 0-211.776 172.224-384 384-384a384.384 384.384 0 0 1 383.936 384A384.384 384.384 0 0 1 512 895.872zM512 256C370.752 256 256 370.816 256 512a256.256 256.256 0 0 0 256 255.936A256.256 256.256 0 0 0 767.936 512 256.32 256.32 0 0 0 512 256z" fill="#D8E4AF" p-id="9052"></path>
                  </svg>
                  <span style="margin-left:5px;">售卖中</span></span>
                <span v-else>已下架</span>
              </template>
            </el-table-column>

            <el-table-column fixed="right" prop="" label="操作" width="100">
              <template slot-scope="scope">
                <el-button type="text" @click="edit(scope.row)">编辑</el-button>
                <el-button :disabled="scope.row.stuBuyNum != 0" type="text" @click="detele(scope.row)">删除</el-button>
              </template>
            </el-table-column>
          </el-table>
          <div style="margin-top: 30px; text-align: right">
            <el-pagination @current-change="handleCurrentChange" :current-page.sync="page_no" :page-size="page_size" layout="total, prev, pager, next" :total="total"></el-pagination>
          </div>
        </el-tab-pane>
        <el-tab-pane label="物品" name="second">
          <div style="overflow: hidden;">
            <div class="fl">
              <el-form :inline="true" :model="formInline" size="mini">
                <el-form-item label="">
                  <el-input v-model="formInline.user" placeholder="输入课程名称"></el-input>
                </el-form-item>
                <el-form-item label="">
                  <el-button type="primary" @click="search">查询</el-button>
                </el-form-item>
                <el-form-item label="">
                  <el-button type="primary" @click="addarticle">新增物品</el-button>
                </el-form-item>
              </el-form>
            </div>
            <div class="fr">
              <el-form :inline="true" size="mini">
                <el-form-item label="商品状态:">
                  <el-radio-group v-model="formInline.resource" @change="search">
                    <el-radio label="1">售卖中</el-radio>
                    <el-radio label="2">已下架</el-radio>
                  </el-radio-group>
                </el-form-item>
              </el-form>
            </div>
          </div>
          <el-table :data="tableData" stripe style="width: 100%" :header-cell-style="{ background: '#f5f7fa' }">
            <el-table-column prop="" label="序号" width="50px">
              <template slot-scope="scope">{{ scope.$index + 1 }}</template>
            </el-table-column>
            <el-table-column prop="name" label="物品名称"> </el-table-column>

            <el-table-column prop="price" label="销售单价(单价:元)">
            </el-table-column>

            <!-- <el-table-column prop="" label="可用状态" width="100">
              <template slot-scope="scope">
                <span v-if="scope.row.state == 1">
                  <svg t="1690013259231" class="icon" viewBox="0 0 1024 1024" version="1.1"
                    xmlns="http://www.w3.org/2000/svg" p-id="8590" width="20" height="20">
                    <path d="M512 192a320 320 0 1 1-0.064 640.064A320 320 0 0 1 512 192z" fill="#B2CA5F" p-id="8591">
                    </path>
                    <path
                      d="M512 895.872c-211.776 0-384-172.16-384-383.936 0-211.776 172.224-384 384-384a384.384 384.384 0 0 1 383.936 384A384.384 384.384 0 0 1 512 895.872zM512 256C370.752 256 256 370.816 256 512a256.256 256.256 0 0 0 256 255.936A256.256 256.256 0 0 0 767.936 512 256.32 256.32 0 0 0 512 256z"
                      fill="#D8E4AF" p-id="8592"></path>
                  </svg>
                </span>
                <span v-else>
                  <svg t="1690013299594" class="icon" viewBox="0 0 1024 1024" version="1.1"
                    xmlns="http://www.w3.org/2000/svg" p-id="8800" width="20" height="20">
                    <path d="M512 192a320 320 0 1 1-0.064 640.064A320 320 0 0 1 512 192z" fill="#d81e06" p-id="8801">
                    </path>
                    <path
                      d="M512 895.872c-211.776 0-384-172.16-384-383.936 0-211.776 172.224-384 384-384a384.384 384.384 0 0 1 383.936 384A384.384 384.384 0 0 1 512 895.872zM512 256C370.752 256 256 370.816 256 512a256.256 256.256 0 0 0 256 255.936A256.256 256.256 0 0 0 767.936 512 256.32 256.32 0 0 0 512 256z"
                      fill="#d81e06" p-id="8802"></path>
                  </svg>
                </span>
              </template>
            </el-table-column> -->
            <el-table-column prop="" label="商品状态" width="100">
              <template slot-scope="scope">
                <span v-if="scope.row.state == 1">
                  <svg t="1690013932997" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="9050" width="10" height="10">
                    <path d="M512 192a320 320 0 1 1-0.064 640.064A320 320 0 0 1 512 192z" fill="#B2CA5F" p-id="9051">
                    </path>
                    <path d="M512 895.872c-211.776 0-384-172.16-384-383.936 0-211.776 172.224-384 384-384a384.384 384.384 0 0 1 383.936 384A384.384 384.384 0 0 1 512 895.872zM512 256C370.752 256 256 370.816 256 512a256.256 256.256 0 0 0 256 255.936A256.256 256.256 0 0 0 767.936 512 256.32 256.32 0 0 0 512 256z" fill="#D8E4AF" p-id="9052"></path>
                  </svg>
                  <span style="margin-left:5px;">售卖中</span></span>
                <span v-else>已下架</span>
              </template>
            </el-table-column>

            <el-table-column prop="" label="操作" width="120">
              <template slot-scope="scope">
                <el-button type="text" @click="edit(scope.row)">编辑</el-button>
                <el-button type="text" @click="detele(scope.row)">删除</el-button>
              </template>
            </el-table-column>
          </el-table>
          <div style="margin-top: 30px; text-align: right">
            <el-pagination @current-change="handleCurrentChange" :current-page.sync="page_no" :page-size="page_size" layout="total, prev, pager, next" :total="total"></el-pagination>
          </div>
        </el-tab-pane>
        <el-tab-pane label="费用" name="third">
          <div style="overflow: hidden;">
            <div class="fl">
              <el-form :inline="true" :model="formInline" size="mini">
                <el-form-item label="">
                  <el-input v-model="formInline.user" placeholder="输入课程名称"></el-input>
                </el-form-item>
                <el-form-item label="">
                  <el-button type="primary" @click="search">查询</el-button>
                </el-form-item>
                <el-form-item label="">
                  <el-button type="primary" @click="addfy">新增费用</el-button>
                </el-form-item>
              </el-form>
            </div>
            <div class="fr">
              <el-form :inline="true" size="mini">
                <el-form-item label="商品状态:">
                  <el-radio-group v-model="formInline.resource" @change="search">
                    <el-radio label="1">售卖中</el-radio>
                    <el-radio label="2">已下架</el-radio>
                  </el-radio-group>
                </el-form-item>
              </el-form>
            </div>
          </div>
          <el-table :data="tableData" stripe style="width: 100%" :header-cell-style="{ background: '#f5f7fa' }">
            <!-- <el-table-column prop="" label="序号" width="50px">
                            <template slot-scope="scope">{{ scope.$index + 1 }}</template>
                        </el-table-column> -->
            <el-table-column prop="name" label="费用名称"> </el-table-column>
            <el-table-column prop="price" label="售卖单价"> </el-table-column>

            <!-- <el-table-column prop="" label="可用状态" width="100">
              <template slot-scope="scope">
                <span v-if="scope.row.state == 1">启用中</span>
                <span v-else>已停用</span>
              </template>
            </el-table-column> -->
            <el-table-column prop="" label="商品状态" width="100">
              <template slot-scope="scope">
                <span v-if="scope.row.state == 1">
                  <svg t="1690013932997" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="9050" width="10" height="10">
                    <path d="M512 192a320 320 0 1 1-0.064 640.064A320 320 0 0 1 512 192z" fill="#B2CA5F" p-id="9051">
                    </path>
                    <path d="M512 895.872c-211.776 0-384-172.16-384-383.936 0-211.776 172.224-384 384-384a384.384 384.384 0 0 1 383.936 384A384.384 384.384 0 0 1 512 895.872zM512 256C370.752 256 256 370.816 256 512a256.256 256.256 0 0 0 256 255.936A256.256 256.256 0 0 0 767.936 512 256.32 256.32 0 0 0 512 256z" fill="#D8E4AF" p-id="9052"></path>
                  </svg>
                  <span style="margin-left:5px;">售卖中</span></span>
                <span v-else>已下架</span>
              </template>
            </el-table-column>

            <el-table-column prop="" label="操作" width="120">
              <template slot-scope="scope">
                <el-button type="text" @click="edit(scope.row)">编辑</el-button>
                <el-button type="text" @click="detele(scope.row)">删除</el-button>
              </template>
            </el-table-column>
          </el-table>
          <div style="margin-top: 30px; text-align: right">
            <el-pagination @current-change="handleCurrentChange" :current-page.sync="page_no" :page-size="page_size" layout="total, prev, pager, next" :total="total"></el-pagination>
          </div>
        </el-tab-pane>
      </el-tabs>
    </div>
    <el-dialog :title="form.id === '' ? '新建课程商品' : '编辑课程商品'" :visible.sync="dialogVisible" width="50%" top="5vh">
      <el-form ref="form" :model="form" size="small" label-width="80px">
        <el-form-item label="所属校区">
          <el-select v-model="form.campusIdArr" multiple collapse-tags placeholder="请选择" style="width:100%">
            <el-option v-for="item in options" :key="item.dept_id" :label="item.campusName" :value="item.dept_id">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="商品名称">
          <el-input style="width:100%;" v-model="form.name" maxlength="200" show-word-limit></el-input>
        </el-form-item>
        <el-form-item label="定价标准">
          <el-table :header-cell-style="{ background: '#f5f7fa' }" size="mini" ref="table" :data="applayList" style="width: 100%;border:1px solid #f7f8f9" height="250">
            <el-table-column prop="name" label="名称">
              <template slot-scope="scope">
                <el-input v-model="scope.row.name" size="mini"></el-input>
              </template>
            </el-table-column>
            <el-table-column prop="acount" label="数量(课时)">
              <template slot-scope="scope">
                <el-input onkeyup="value=value.match(/\d+\.?\d{0,2}/);" v-model="scope.row.acount" size="mini"></el-input>
              </template>
            </el-table-column>
            <el-table-column prop="total_price" label="总价(元)">
              <template slot-scope="scope">
                <el-input onkeyup="value=value.match(/\d+\.?\d{0,2}/);" v-model="scope.row.total_price" size="mini"></el-input>
              </template>
            </el-table-column>

            <el-table-column prop="" label="单价(元/课时)">
              <template slot-scope="scope">
                <span v-if="isNaN((scope.row.total_price / scope.row.acount).toFixed(2))">
                  0
                </span>
                <span v-else>
                  {{
                    (scope.row.total_price / scope.row.acount).toFixed(2)
                  }}
                </span>
              </template>
            </el-table-column>
            <el-table-column label="操作">
              <template slot-scope="scope">
                <el-button type="text" @click.native.prevent="
                applaydeleteRow(scope.$index, applayList)
                  " size="mini">
                  移除
                </el-button>
              </template>
            </el-table-column>
          </el-table>
          <el-row style="border:0;">
            <el-col style="text-align:center;"><el-button type="text" size="small" style="border-top:none; position: relative;margin-top:10px;" @click="applayaddRow(applayList)">+
                添加标准</el-button></el-col>
          </el-row>
        </el-form-item>
        <el-form-item label="备注信息">
          <el-input style="width:100%;" v-model="form.remark" maxlength="255" show-word-limit></el-input>
        </el-form-item>
        <el-form-item label="可用状态">
          <el-radio-group v-model="form.state">
            <el-radio label="1">启用</el-radio>
            <el-radio label="2">停用</el-radio>
          </el-radio-group>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="submitsub">确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog title="新建物品" :visible.sync="dialogVisible1" width="50%">
      <el-form ref="form" :model="form" size="mini">
        <el-form-item label="校区">
          <el-select v-model="form.campusIdArr" multiple collapse-tags placeholder="请选择" style="width:220px">
            <el-option v-for="item in options" :key="item.dept_id" :label="item.campusName" :value="item.dept_id">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="物品名称">
          <el-input v-model="form.wpname"></el-input>
        </el-form-item>

        <el-form-item label="售卖单价">
          <el-input v-model="form.price" oninput="value=value.replace(/[^0-9.]/g,'')">
            <template slot="append">元</template>
          </el-input>
        </el-form-item>
        <el-form-item label="可用状态:">
          <el-radio-group v-model="form.state">
            <el-radio label="1">启动</el-radio>
            <el-radio label="2">停用</el-radio>
          </el-radio-group>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible1 = false">取 消</el-button>
        <el-button type="primary" @click="submitwp">确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog title="新建费用" :visible.sync="dialogVisible2" width="50%">
      <el-form ref="form" :model="form" size="mini">
        <el-form-item label="校区">
          <el-select v-model="form.campusIdArr" multiple collapse-tags placeholder="请选择" style="width:220px">
            <el-option v-for="item in options" :key="item.dept_id" :label="item.campusName" :value="item.dept_id">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="费用名称">
          <el-input v-model="form.name"></el-input>
        </el-form-item>

        <el-form-item label="售卖单价">
          <el-input v-model="form.price" oninput="value=value.replace(/[^0-9.]/g,'')">
            <template slot="append">元</template>
          </el-input>
        </el-form-item>
        <el-form-item label="商品状态:">
          <el-radio-group v-model="form.state">
            <el-radio label="1">启动</el-radio>
            <el-radio label="2">停用</el-radio>
          </el-radio-group>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible2 = false">取 消</el-button>
        <el-button type="primary" @click="submitfy">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import {
  addOrUpdateXmGoods,
  getXmGoodsList,
  deleteXmGoods,
  udpateXmGoodsState,
  getUserCampusList,
} from "@/api/educational";

export default {
  data() {
    return {
      options: [],
      type: "1",
      page_no: 1,
      page_size: 10,
      total: 0,
      tableDatafy: [],
      tableDatawp: [],
      applayList: [],
      dialogVisible: false,
      dialogVisible1: false,
      dialogVisible2: false,

      activeName: "first",
      formInline: {
        resource: "1",
      },
      form: {
        price: "",
        wpname: "",
        remark: "",
        name: "",
        state: "1",
        id: "",
        campusIdArr: [],
      },
      tableData: [],
    };
  },
  mounted() {
    this.getUserCampusList();
    this.getXmGoodsList();
  },
  methods: {
    getUserCampusList() {
      getUserCampusList({}).then((res) => {
        console.log(res, 152121);
        this.form.campusIdArr = [];
        this.options = res.userDeptList;
        res.userDeptList.map((item) => {
          this.form.campusIdArr.push(item.dept_id);
        });
      });
    },
    //编辑
    edit(row) {
      console.log(row, 1323);
      console.log(row.name, 1323);
      row.rule_pricePase = window.JSON.parse(row.rule_price);
      row.rule_pricePase.forEach(priceItem => {
        priceItem.unit_price = priceItem.unit_price || 0;
        priceItem.total_price = priceItem.total_price || 0;
      })
      this.form.campusIdArr = row.campus_id_arr;
      this.form.id = row.id;
      this.form.name = row.name;
      this.type = row.type.toString();
      this.form.remark = row.remark;
      this.applayList = row.rule_pricePase;
      this.state = row.state.toString();
      this.form.price = row.price;
      this.form.wpname = row.name;
      this.form.state = row.state.toString()
      console.log(this.type, 1323);

      if (this.type === "1") {
        this.dialogVisible = true;
      }
      if (this.type === "2") {
        this.dialogVisible1 = true;
      }
      if (this.type === "3") {
        this.dialogVisible2 = true;
      }
    },
    //
    submitfy() {
      if (this.form.id === "") {
        addOrUpdateXmGoods({
          campusIdArr: JSON.stringify(this.form.campusIdArr),
          type: this.type,
          name: this.form.name,
          price: this.form.price,
          state: this.form.state,
        }).then(() => {
          this.dialogVisible2 = false;
          this.getXmGoodsList();
          this.$message({
            type: "success",
            message: "添加成功!",
          });
        });
      } else {
        addOrUpdateXmGoods({
          campusIdArr: JSON.stringify(this.form.campusIdArr),
          id: this.form.id,
          type: this.type,
          name: this.form.name,
          price: this.form.price,
          state: this.form.state,
        }).then(() => {
          this.dialogVisible2 = false;
          this.getXmGoodsList();
          this.$message({
            type: "success",
            message: "编辑成功!",
          });
        });
      }
    },
    //
    submitwp() {
      if (this.form.id === "") {
        addOrUpdateXmGoods({
          campusIdArr: JSON.stringify(this.form.campusIdArr),
          type: this.type,
          name: this.form.wpname,
          price: this.form.price,
          state: this.form.state,
        }).then(() => {
          this.dialogVisible1 = false;
          this.getXmGoodsList();
          this.$message({
            type: "success",
            message: "添加成功!",
          });
        });
      } else {
        addOrUpdateXmGoods({
          campusIdArr: JSON.stringify(this.form.campusIdArr),

          id: this.form.id,
          type: this.type,
          name: this.form.wpname,
          price: this.form.price,
          state: this.form.state,
        }).then(() => {
          this.dialogVisible1 = false;
          this.getXmGoodsList();
          this.$message({
            type: "success",
            message: "编辑成功!",
          });
        });
      }
    },
    //
    search() {
      this.page_no = 1;
      this.getXmGoodsList();
    },
    changeSwitch(row) {
      udpateXmGoodsState({
        id: row.id,
        state: row.state,
      }).then(() => {
        this.$message({
          type: "success",
          message: "更新成功!",
        });
        this.getXmGoodsList();
      });
    },
    //删除
    detele(row) {
      // deleteXmGoods
      this.$confirm("是否确认删除?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          deleteXmGoods({
            id: row.id,
          }).then(() => {
            this.$message({
              type: "success",
              message: "删除成功!",
            });
            this.getXmGoodsList();
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
    //获得商品列表
    getXmGoodsList() {
      getXmGoodsList({
        campusIdArr: JSON.stringify(this.$store.state.user.selected_schools),
        state: this.formInline.resource,
        type: this.type,
        name: this.formInline.user,
        page_no: this.page_no,
        page_size: this.page_size,
      }).then((res) => {
        this.tableData = res.xmGoodsObj;
        this.tableData.forEach(item => {
          item.rule_pricePase = window.JSON.parse(item.rule_price);
          item.rule_pricePase.forEach(priceItem => {
            priceItem.unit_price = priceItem.unit_price || 0;
            priceItem.total_price = priceItem.total_price || 0;
          })
        })
        this.total = res.total;
      });
    },
    handleCurrentChange(val) {
      this.page_no = val;
      this.getXmGoodsList();
    },

    //新增课程
    submitsub() {
      if (this.applayList.length == 0) {
        this.$message.warning('定价标准不能为空')
        return false
      }
      console.log(1212);
      this.applayList.map((item) => {
        if (isNaN((item.total_price / item.acount).toFixed(2))) {
          item.unit_price = 0
        } else {
          item.unit_price =
            parseFloat(item.total_price).toFixed(2) /
            parseFloat(item.acount).toFixed(2);
        }
      });
      if (this.form.id === "") {
        console.log(this.applayList, 113233);
        addOrUpdateXmGoods({
          campusIdArr: JSON.stringify(this.form.campusIdArr),
          type: this.type,
          name: this.form.name,
          rule_price: JSON.stringify(this.applayList),
          remark: this.form.remark,
          state: this.form.state,
        }).then(() => {
          this.dialogVisible = false;
          this.getXmGoodsList();
          this.$message({
            type: "success",
            message: "添加成功!",
          });
        });
      } else {
        console.log(this.applayList, 113233);
        addOrUpdateXmGoods({
          campusIdArr: JSON.stringify(this.form.campusIdArr),
          id: this.form.id,
          type: this.type,
          name: this.form.name,
          rule_price: JSON.stringify(this.applayList),
          remark: this.form.remark,
          state: this.form.state,
        }).then(() => {
          this.dialogVisible = false;
          this.getXmGoodsList();
          this.$message({
            type: "success",
            message: "编辑成功!",
          });
        });
      }
    },
    handleClick(val) {
      console.log(val);
      if (val.name === "first") {
        this.type = "1";
        this.page_no = 1;
        this.getXmGoodsList();
      }
      if (val.name === "second") {
        this.type = "2";
        this.page_no = 1;

        this.getXmGoodsList();
      }
      if (val.name === "third") {
        this.type = "3";
        this.page_no = 1;
        console.log(this.type, 12121);

        this.getXmGoodsList();
      }
    },
    addSub() {
      this.form.id = "";
      this.form.name = "";
      this.type = "1";
      this.form.remark = "";
      this.applayList = [
      ];
      this.state = "1";
      this.form.price = "";
      this.form.wpname = "";
      this.dialogVisible = true;
    },
    //添加表格里的行(申请状态)
    applayaddRow(tableData1) {
      tableData1.push({
        name: "",
        acount: 0,
        total_price: 0,
        unit_price: '',
      });
    },
    //删除表格里的行(申请状态)
    applaydeleteRow(index, rows) {
      rows.splice(index, 1);
    },
    addarticle() {
      this.form.id = "";
      this.form.name = "";
      this.type = "2";
      this.form.remark = "";
      this.applayList = [];
      this.state = "1";
      this.form.price = "";
      this.form.wpname = "";
      this.dialogVisible1 = true;
    },
    addfy() {
      this.form.id = "";
      this.form.name = "";
      this.type = "3";
      this.form.remark = "";
      this.applayList = [];
      this.state = "1";
      this.form.price = "";
      this.form.wpname = "";
      this.dialogVisible2 = true;
    },
  },
};
</script>

<style lang="scss" scoped>
.mainNew {
  height: 100%;
}

.topTitle {
  height: 60px;
  background: #fff;
  margin: 10px;
  padding: 20px;
  border-radius: 5px;
  box-sizing: border-box;
  font-size: 14px;

  span {
    color: rgba(0, 0, 0, 0.45);
  }
}

.container {
  min-height: calc(100% - 30px);
  background-color: #ffffff;
  border-radius: 5px;
  margin: 10px;

  padding-left: 20px;
  padding-right: 20px;
  padding-top: 10px;
  padding-bottom: 10px;

  // width: 100%;
  // height: 100%;

  // min-width: 1000px;
  // overflow: hidden;

  .basic-settings-body {
    .create-campus {
    }

    .search-list {
      margin-top: 20px;
      display: inline-block;
    }
  }

  .editStopDayShow {
    padding: 1 5px 0;
  }

  .transfer-footer {
    margin-left: 20px;
    padding: 6px 5px;
  }

  .wechat {
    margin-top: 20px;

    .wechat_head {
      width: 50px;
      height: 50px;
    }

    .wechat_name {
      line-height: 40px;
      position: relative;
      display: inline-block;
      overflow: hidden;
      margin-left: 20px;
    }

    .wechat_label {
      line-height: 40px;
      position: relative;
      display: inline-block;
      overflow: hidden;
      margin-left: 20px;
      color: green;
      font-weight: bold;
    }

    .wechat_download {
      line-height: 40px;
      position: relative;
      display: inline-block;
      overflow: hidden;
      margin-left: 50px;
      color: #529dfe;
      font-weight: bold;
      cursor: pointer;
    }
  }
}

.fl {
  float: left;
}

.fr {
  float: right;
}

/deep/.el-dialog {
  border-radius: 10px !important;
}
</style>

<style>
.el-transfer-panel {
  width: 40%;
}
</style>
